import { BRAND } from "../../../constants"
import { Menu as MenuType } from "../../../models/interfaces/MegaMenu.interface"
import Menu from "./Menu"

type DropDownProps = {
    menu: MenuType | null
}

const DropDown = ({ menu }: DropDownProps) => {
  if (!menu) return null
  return (
    <div className='drop-down-container'>
      <Menu links={menu.links} title={menu.title} />
      <style jsx>{`
        .drop-down-container {
          width: 100%;
          min-height: 704px;
          left: 0;
          top: 100px;
          background-color: white;
          position: absolute;
          border: 1px solid #f1f1f1;
          z-index: 1000;
        }

        @media screen and (max-width: ${BRAND.media.small}px) {
          .drop-down-container {
            width: 300px;
          }
        }
      `}</style>
    </div>
  )
}

export default DropDown